import React from 'react'
import './notiItem.scss'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { showNotiDropdown } from '../../../../redux/notifications/notifications-actions'
import {ReactComponent as Comment} from '../../../../assets/comment.svg';
import {ReactComponent as Lovefire} from '../../../../assets/lovefire.svg';
import {ReactComponent as Follower} from '../../../../assets/follower.svg';
import { MoonLoader } from 'react-spinners';

const NotiItem = ({noti, showNotiDropdown, getUpdateNoti, isLoading,
  endOfNewNotis}) => {

  const history = useHistory();
  
  
  switch (noti.notiType) { 
    case 'comment':
      return (
        <div className='noti-item'>
          <div className='details'>
            <div style={{width: '15%'}} >
              <Comment style={{marginRight: '5px', width: '30px', height: '30px'}} />
            </div>
            <div>
              <span className='details-info' ><span className='details-name' 
              onClick={() => {
                history.push(`/p/${noti.notiMakerId}`);
                showNotiDropdown();
              }}
              >{noti.notiMakerName}</span>commented on your experience <span className='details-name' onClick={() => {
                history.push(`/exp/${noti.expId}`);
                showNotiDropdown();
              }} >"{noti.expTitle}"</span></span>
            </div>
          </div>
        </div>
      )
    case 'vote':
      return (
        <div className='noti-item'>
          <div className='details'>
            <div style={{width: '15%'}} >
              <Lovefire className='logo-header2' style={{marginRight: '5px'}} />
            </div>
            <div>
              <span className='details-info' ><span className='details-name'
              onClick={() => {
                history.push(`/p/${noti.notiMakerId}`);
                showNotiDropdown();
              }}
              >{noti.notiMakerName}</span>voted your experience <span className='details-name'
              onClick={() => {
                history.push(`/exp/${noti.expId}`);
                showNotiDropdown(); 
              }}>"{noti.expTitle}"</span></span>
            </div>
          </div>
        </div>
      )
    case 'following':
      return (
        <div className='noti-item'>
          <div className='details'>
            <div style={{width: '15%'}} >
              <Follower className='logo-header2' style={{marginRight: '5px'}} />
            </div>
            <div>
              <span className='details-info' ><span className='details-name'
              onClick={() => {
                history.push(`/p/${noti.notiMakerId}`);
                showNotiDropdown();
              }}
              >{noti.notiMakerName}</span>started following you</span>
            </div>
          </div>
        </div>
      )
    default:
      return (
        <div className='noti-item1' >
          <div className={endOfNewNotis ? 'efgh' : 'abcd'}
          onClick={endOfNewNotis ? (() => {}) : (getUpdateNoti)} >
            {isLoading ? 
            <MoonLoader loading={isLoading} size={22} /> :
            (endOfNewNotis ? 'End of notifications' : 'reload more')}
          </div>
        </div>
      )
  }
}

const mapStateToProps = state => ({
  endOfNewNotis: state.notifications.endOfNewNotis
})

export default connect(mapStateToProps, { showNotiDropdown })(NotiItem);